import {
  ICreateCompanyReq,
  ICompany,
  IUpdateGoogleAds
} from "../../models/company/index";
import {
  IBasePagingRes,
  IBaseResponse,
  IBaseResponseModel
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { IPayroll } from "@/models/payroll";
import { IGetUsersReq } from "@/models/user";

const API = ApiEndpoints.PAYROLL;
const baseURL = envConfig.API_ENDPOINT;

const getPage = (data: IGetUsersReq): Promise<IBasePagingRes<any>> => {
  return api.get(baseURL, API.GET_PAGE.url, {
    params: data
  });
};

const create = (params: FormData): Promise<IBaseResponseModel<IPayroll>> => {
  return api.post(baseURL, API.CREATE.url, params, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const PayrollService = {
  getPage,
  create
};

export default PayrollService;
